import React from "react";
import {
  Header,
  AnimatedBackground,
  HeroSection,
  StudentFeatures,
  TrainerFeatures,
  PricingSection,
  CTASection,
  Footer,
  LandingStyles,
  useLandingAnimations,
} from "../../components/landing";

export default function EasyfitLanding() {
  const { isDark, scrollY, visibleSections, toggleTheme } =
    useLandingAnimations();

  return (
    <div className={isDark ? "dark" : ""}>
      <div className="min-h-screen bg-white dark:bg-black text-gray-900 dark:text-white transition-colors duration-500">
        <AnimatedBackground />
        <div className="relative z-10">
          <Header
            isDark={isDark}
            scrollY={scrollY}
            onToggleTheme={toggleTheme}
          />
          <HeroSection />
          <StudentFeatures visibleSections={visibleSections} />
          <TrainerFeatures visibleSections={visibleSections} />
          <PricingSection visibleSections={visibleSections} />
          <CTASection visibleSections={visibleSections} />
          <Footer />
        </div>
      </div>
      <LandingStyles />
    </div>
  );
}
